import { create } from 'zustand';
import { Workspace } from '../types';
import { apiService } from '../services/api';

interface WorkspaceStore {
  workspaces: Workspace[];
  currentWorkspace: Workspace | null;
  isLoading: boolean;
  error: string | null;

  // Actions
  loadWorkspaces: () => Promise<void>;
  selectWorkspace: (workspace: Workspace) => Promise<void>;
  setError: (error: string | null) => void;
}

export const useWorkspaceStore = create<WorkspaceStore>((set, get) => ({
  workspaces: [],
  currentWorkspace: null,
  isLoading: false,
  error: null,

  loadWorkspaces: async () => {
    set({ isLoading: true, error: null });

    try {
      const workspaces = await apiService.getWorkspaces();
      set({ 
        workspaces, 
        isLoading: false,
        // Don't auto-select first workspace - let user choose
      });
    } catch (error) {
      console.error('Failed to load workspaces:', error);
      set({
        error: error instanceof Error ? error.message : 'Failed to load workspaces',
        isLoading: false,
      });
    }
  },

  selectWorkspace: async (workspace) => {
    // Set the basic workspace immediately for UI responsiveness
    set({ currentWorkspace: workspace });
    
    // Store selection in localStorage for persistence
    localStorage.setItem('selectedWorkspaceId', workspace.id);
    
    try {
      // Fetch the full workspace details including common actions
      const fullWorkspace = await apiService.getWorkspace(workspace.id);
      
      // Update with the full workspace data
      set({ currentWorkspace: fullWorkspace });
    } catch (error) {
      console.error('Failed to fetch full workspace details:', error);
      // Keep the basic workspace data if full fetch fails
    }
    
    // Note: Chat store configuration will be handled by the ChatInterface component
    // when it detects the workspace change
  },

  setError: (error) => {
    set({ error });
  },
}));